<template>
    <el-table
            :data="propsTableData"
            style="width: 100%"
            class="table-wrap remote-table-wrap">
        <!--<el-table-column-->
                <!--prop="consultGroupNo"-->
                <!--label="编号"-->
                <!--align="center"-->
                <!--show-overflow-tooltip>-->
        <!--</el-table-column>-->
        <el-table-column
                prop="hasAtta"
                width="30"
                align="center">
            <template slot-scope="scope">
                <span v-show="scope.row.hasAtta==true" >
                            <svg class="icon" aria-hidden="true" style="font-size:24px;color:#888888;">
                                <use xlink:href="#icon-biaoqianshuqianhuixingzhen"></use>
                            </svg>
                </span>
                <span v-show="scope.row.hasAtta==false"></span>
            </template>
        </el-table-column>
        <el-table-column
                prop="consulterName"
                label="患者"
                align="center"
                width="67">
        </el-table-column>
        <!--<el-table-column-->
                <!--prop="consulterGender"-->
                <!--label="性别"-->
                <!--:formatter="sexSelect"-->
                <!--width="60"-->
                <!--align="center">-->
        <!--</el-table-column>-->
        <!--<el-table-column-->
                <!--prop="consulterAge"-->
                <!--label="年龄"-->
                <!--align="center"-->
                <!--width="60">-->
        <!--</el-table-column>-->
        <el-table-column
                prop="initHosName"
                label="申请机构"
                align="center"
                show-overflow-tooltip>
        </el-table-column>
        <el-table-column
                prop="initDeptName"
                label="申请科室"
                align="center"
                show-overflow-tooltip>
        </el-table-column>
        <el-table-column
                prop="initDocName"
                label="申请医生"
                align="center"
                show-overflow-tooltip>
        </el-table-column>
        <el-table-column
                prop="createTime"
                label="申请时间"
                :formatter="formatUnix"
                width="60"
                align="center">
        </el-table-column>
        <el-table-column
                prop=""
                label="会诊机构"
                align="center"
                width="75">
            <template slot-scope="scope">
                <span>{{ scope.row.hopeHosName ? scope.row.hopeHosName : scope.row.acceptHosName }}</span>
            </template>
        </el-table-column>
        <el-table-column
                prop=""
                label="会诊科室"
                align="center"
                width="80">
            <template slot-scope="scope">
                <span>{{ scope.row.hopeDeptName ? scope.row.hopeDeptName : scope.row.acceptDeptName }}</span>
            </template>
        </el-table-column>
        <el-table-column
                prop=""
                label="会诊专家"
                align="center"
                width="60"
                show-overflow-tooltip>
            <template slot-scope="scope">
                <span>{{ scope.row.hopeDocName ? scope.row.hopeDocName : scope.row.acceptDocName }}</span>
            </template>
        </el-table-column>
        <el-table-column
                prop="consultTime"
                label="安排会诊"
                :formatter="formatUnixConsultTime"
                align="center"
                width="60">
        </el-table-column>
        <el-table-column
                prop=""
                label="资料是否就绪"
                align="center"
                width="80">
            <template slot-scope="scope">
                <span :class="[scope.row.readyStatus?'table-status-green':'table-status-red']">{{ scope.row.readyStatus?"是":"否" }}</span>
            </template>
        </el-table-column>
        <el-table-column
                prop=""
                label="时间是否安排"
                :formatter="isTimeReady"
                align="center"
                width="80">
            <template slot-scope="scope">
                <span :class="[scope.row.consultTime?'table-status-green':'table-status-red']">{{ scope.row.consultTime?"是":"否" }}</span>
            </template>
        </el-table-column>
        <el-table-column
                prop="modifierName"
                label="最后处理人"
                align="center"
                width="80">
        </el-table-column>
        <el-table-column
                prop="modifyTime"
                label="最后处理"
                :formatter="formatModifyUnix"
                align="center"
                width="60">
        </el-table-column>
        <el-table-column
                prop="operation"
                label=" 操作"
                align="center"
                inline-template
                width="180">
            <div class="table-btn-wrap">
                <el-button
                        size="small"
                        @click="linkToView($index, row)"
                        class="table-btn ghost-btn">
                    会诊单
                </el-button>
                <el-button
                        size="small"
                        type="primary"
                        @click="linkToDeal($index, row)"
                        class="table-btn operate">
                    处理
                </el-button>
            </div>
        </el-table-column>
    </el-table>
</template>
<style>

</style>
<script>
    import { Table,Button,TableColumn, Tooltip } from "element-ui";
    import { formatUnixTime } from "../../utils/DateFormat.js";
    import Vue from "vue";
    Vue.use(Table);
    Vue.use(Button);
    Vue.use(TableColumn);
    Vue.use(Tooltip);
    export default{
        props: ["propsTableData", "tableType"],
        components:{

        },
        methods: {
            formatUnix: function(row, column){//格式化时间格式
                return formatUnixTime(row.createTime, "MM-dd HH:mm");
            },
            formatUnixConsultTime: function (row, column) {//格式化会诊时间
                if(row.consultTime){
                    return formatUnixTime(row.consultTime, "MM-dd HH:mm");
                }else {
                    return "";
                }
            },
            sexSelect: function(row, column){//根据服务器获取到的M或者其他显示男或女
                return (row.consulterGender =="M"?"男":"女");
            },
            formatModifyUnix: function(row, column){//格式化最后处理时间格式
                if(row.modifyTime){
                    return formatUnixTime(row.modifyTime, "MM-dd HH:mm");
                }else {
                    return "";
                }
            },
            isTimeReady: function(row, column){//是否安排会诊时间
                return (row.consultTime?"是":"否");
            },
            isDataReady: function () {//资料是否就绪

            },
            linkToView: function($index, row){
//                this.$router.push({ name: "remoteSheet", params: { consultId: row.consultId }} );
                this.$router.push({ name: "printRemoteSheet", params: { consultId: row.consultId ,printDetail:row}})
                //this.$emit("linkToLeft");
            },
            linkToDeal: function($index, row){
                if(row.consultTime){
                    this.$store.dispatch("getSideBarTitle", "待会诊");
                }else {
                    this.$store.dispatch("getSideBarTitle", "待处理(我的)");
                }
                this.$store.dispatch("getCurrentPosition", this.tableType);// 更改侧边栏列表获取数据
                this.$router.push({ name: "remoteEntry", params: { consultId: row.consultId }} );
            }
        }
    }
</script>
